const mapTimeStrToObject = timeStr => {
  const [date, time] = timeStr.split(' ');
  const [year, month, day] = date.split('-');
  const [hour, minute, dirtySecond] = time.split(':');
  const [second] = dirtySecond.split('.');

  return {
    date: {
      year,
      month,
      day,
    },
    time: {
      hour,
      minute,
      second,
    },
  };
};

const mapObjectToDate = (dateObj, isAmericanDate = true) => {
  const {
    date: { year, month, day },
  } = dateObj;
  return isAmericanDate ? `${month}/${day}/${year}` : `${year}/${month}/${day}`;
};

export const mapDateFromApiModel = apiDate =>
  mapObjectToDate(mapTimeStrToObject(apiDate));
